import { jsx as _jsx } from "react/jsx-runtime";
import { Kfw } from "./Logos/Kfw";
export const PartnerBoxLogo = (props) => {
    if (props.partnerKey === "kfw")
        return _jsx(Kfw, {});
    return null;
};
